import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-133927be"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: $props.id,
    style: {
      "width": "700px",
      "height": "400px"
    }
  }, null, 8, _hoisted_1);
}